import { type FieldValue } from "~/components/job_posts/field";
import { type Question } from "~/types/jben/job_post";
import { type QuickApplyProfile } from "./types";

export class Autofiller {
  private answers: Record<string, FieldValue>;
  private setAnswers: (answers: Record<string, FieldValue>) => void;
  private questions: Question[];

  constructor(
    answers: Record<string, FieldValue>,
    setAnswers: (answers: Record<string, FieldValue>) => void,
    questions: Question[]
  ) {
    this.answers = answers;
    this.setAnswers = setAnswers;
    this.questions = questions;
  }

  fill(profile: QuickApplyProfile): void {
    const newAnswers = {
      ...this.answers,
      first_name: this.chooseAnswer("first_name", profile.firstName),
      last_name: this.chooseAnswer("last_name", profile.lastName),
      email: this.chooseAnswer("email", profile.email),
      phone: this.chooseAnswer("phone", profile.phoneNumber),
      location: this.chooseAnswer("location", profile.location?.displayName),
      latitude: this.chooseAnswer("latitude", profile.location?.latitude.toString()),
      longitude: this.chooseAnswer("longitude", profile.location?.longitude.toString()),
    } as typeof this.answers;

    if (this.hasPreferredNameField) {
      newAnswers.preferred_name = this.chooseAnswer("preferred_name", profile.preferredName);
    }

    this.setAnswers(newAnswers);
  }

  private chooseAnswer(key: string, autofillAnswer?: string | null) {
    const existingAnswer = this.answers[key];

    if (typeof existingAnswer === "object" && existingAnswer != null) {
      return existingAnswer;
    }

    return existingAnswer?.trim() || autofillAnswer || "";
  }

  private get hasPreferredNameField(): boolean {
    return this.questions.some((question) => question.fields[0]?.name === "preferred_name");
  }
}
